import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/status/';

interface DTO {
    parkingId: string;
    refetch?: boolean;
}

type ParkingStatus = {
    available: boolean | null;
};

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<ParkingStatus> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ refetch = true, config, ...params }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, params],
        queryFn: async () => await queryFn(params),
        refetchInterval: refetch
            ? (query) => {
                  const available = query.state.data?.available;
                  if (available === undefined) return 15000;
                  return available ? 5 * 60 * 1000 : 15 * 1000;
              }
            : false,
        refetchIntervalInBackground: false,
        ...config,
    });
};

export { RESOURCE as GET_PARKING_STATUS_RESOURCE, useQueryHook as useGetParkingStatus };
